export const AdvertisementValidation = (json) => {
  const MyPromiss = new Promise((resolve, reject) => {
    var errorJson = {};
    
    // Helper function to safely handle string operations
    const safeStringTrim = (value) => {
      if (value === null || value === undefined) return '';
      return typeof value === 'string' ? value.trim() : String(value).trim();
    };
    
    // Description validation
    if (!json?.description || safeStringTrim(json.description) === "") {
      Object.assign(errorJson, { description: "Description cannot be empty *" });
    }
    
    // Service validation
    if (!json?.parentId || safeStringTrim(json.parentId) === "") {
      Object.assign(errorJson, { parentId: "Please select a service *" });
    }
    
    // Discount validation
    if (!json?.discount || safeStringTrim(json.discount) === "") {
      Object.assign(errorJson, { discount: "Discount percentage cannot be empty *" });
    }


    

    
    resolve(errorJson);
  });
  
  return MyPromiss;
}